import { render, staticRenderFns } from "./nearbyActivity.vue?vue&type=template&id=5fe55c21&"
import script from "./nearbyActivity.vue?vue&type=script&lang=js&"
export * from "./nearbyActivity.vue?vue&type=script&lang=js&"
import style0 from "./nearbyActivity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports